import { URLASSOLUTO } from "./variables";
import Swal from "./sweetalert2";
import flatpickr from "flatpickr";
import { Italian } from "flatpickr/dist/l10n/it.js";

document.addEventListener("DOMContentLoaded", async function () {
  let flatpickr = document.querySelector(".flatpickr");
  if (flatpickr) {
    // recupero date corsi
    const { data } = await axios.get(`${URLASSOLUTO}/calendario`);
    //console.log(data);

    document.querySelector(".flatpickr").flatpickr({
      inline: true,
      locale: Italian,
      ariaDateFormat: "Y-m-d",
      minDate: "today",
      maxDate: new Date().fp_incr(730),
      enable: data,
      onDayCreate: function (dObj, dStr, fp, dayElem) {
        dayElem.classList.add("vaiADataCalendario");
        dayElem.addEventListener("click", (e) => {
          let ariaLabel = dayElem.getAttribute("aria-label");
          let dataFormattata = ariaLabel.split("-");
          let dataCorso = `${dataFormattata[2]}/${dataFormattata[1]}/${dataFormattata[0]}`;

          Swal.fire({
            title: `${dataCorso}`,
            html: `Vuoi guardare i corsi disponibili in questa data?`,
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, mostra",
            cancelButtonText: "Annulla",
          }).then((result) => {
            if (result.value == true) {
              window.location.href = `${URLASSOLUTO}/catalogo/corsi-${ariaLabel}`;
            }
          });
        });
      },
    });
  }
});
